import * as React from 'react';
import { Image } from 'react-native';
import {
    BodyLargeEmphasized,
    Card,
    isWeb,
    LabelRegular,
    ScrollView,
    View,
    XStack,
} from 'smoothie';

import { useMembershipGuidanceSessionInfo } from '../hooks/useMembershipGuidanceSessionInfo';
import type { GuidanceSession } from '../types/GuidanceSessions';

interface PastSessionsListProps {
    sessions: GuidanceSession[];
}

const PastSessionsList = ({ sessions }: PastSessionsListProps) => {
    const sessionCount = sessions.length;

    return (
        <ScrollView
            horizontal
            showsHorizontalScrollIndicator={isWeb}
            marginHorizontal={isWeb ? 0 : -28}
            paddingBottom={isWeb ? 16 : 0}
        >
            <XStack gap={12}>
                {!isWeb && <PaddingCard />}

                {sessions.map((session) => (
                    <PastSessionCard key={session.id} session={session} />
                ))}

                {!isWeb && sessionCount > 2 && <PaddingCard />}
            </XStack>
        </ScrollView>
    );
};

const PaddingCard = () => {
    return <Card backgroundColor="rgba(0,0,0,0)" width={16}></Card>;
};

const PastSessionCard = ({ session }: { session: GuidanceSession }) => {
    const { getSessionDetails } = useMembershipGuidanceSessionInfo();
    const sessionStartAsDate = new Date(session.startTime);
    const formattedSessionStart = sessionStartAsDate.toLocaleString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });

    const sessionDetails = getSessionDetails(session.type);
    const { title, image } = sessionDetails;

    return (
        <Card
            backgroundColor="$white"
            borderColor="$gray200"
            borderWidth={1}
            padding={12}
            width={178}
            height={178}
        >
            <View
                width={88}
                height={88}
                justifyContent="center"
                alignItems="center"
                borderRadius={12}
                backgroundColor="$peach500"
            >
                <Image
                    source={image}
                    resizeMode="contain"
                    style={{
                        height: 60,
                    }}
                />
            </View>

            <BodyLargeEmphasized marginTop={16} marginBottom={4}>
                {title}
            </BodyLargeEmphasized>

            <LabelRegular color="$gray1000">
                {formattedSessionStart} &bull; {session.guide?.firstName}
            </LabelRegular>
        </Card>
    );
};

export default PastSessionsList;
